"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const Text_1 = __importDefault(require("./Text"));
const FullStarIcon_1 = __importDefault(require("../icons/FullStarIcon"));
const HalfStarIcon_1 = __importDefault(require("../icons/HalfStarIcon"));
const EmptyStarIcon_1 = __importDefault(require("../icons/EmptyStarIcon"));
const styles_1 = require("../styles");
function getRatingStars(rate) {
    const starsArray = [];
    for (let i = 0; i < 5; i++) {
        const isFullStar = rate > 0 && (1 % rate === 1 || rate === 1);
        const isHalfStar = rate % 1 < 1 && rate % 1 > 0;
        const style = i !== 5 ? styles.starIcon : undefined;
        if (isFullStar)
            starsArray.push(react_1.default.createElement(FullStarIcon_1.default, { style: style, key: i }));
        else if (isHalfStar)
            starsArray.push(react_1.default.createElement(HalfStarIcon_1.default, { style: style, key: i }));
        else
            starsArray.push(react_1.default.createElement(EmptyStarIcon_1.default, { style: style, key: i }));
        rate--;
    }
    return starsArray;
}
const Rating = ({ value, count, style }) => {
    return (react_1.default.createElement(react_native_1.View, { style: react_native_1.StyleSheet.flatten([styles.container, style]) },
        getRatingStars(value),
        react_1.default.createElement(Text_1.default, { margin: "none", color: "secondary", style: styles.text },
            "(",
            count,
            " \u0646\u0638\u0631)")));
};
exports.default = Rating;
const styles = react_native_1.StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    starIcon: {
        marginEnd: styles_1.getSpacing(0.5),
    },
    text: {
        marginStart: styles_1.getSpacing(0.5),
    },
});
